//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'
import * as moment from 'moment'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'
import ArrayStore from 'devextreme/data/array_store'
import DataSource from "devextreme/data/data_source"

//#endregion

import { ScopeBaseGrid } from '../../common/common.base.grid.controller'
import { GridBridge } from '../../common/common.interfaces'
import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { CommonHelper } from '../../../helpers/common-helper'
import { EventsNames } from '../../../helpers/events-names'
import { ColumnModel, ObjectReferenceModel } from '../../api/api.models'
import { GridOptions, GridTypes } from '../../common/grid/grid.controller'
import { i18n } from '../i18n/common.i18n'
import { Md5Objects } from '../toolbar-popover/toolbar-popover.directive'
import { Permissions } from '../../../helpers/permissions'
import { Enums } from '../../../models/common/enums'

import { LocalizationHelper, ConfigHelper, TypeHelper } from '../../../helpers'
import { ValidationControlsService, DateBoxControlsService } from '../../../services/controls'
import { IMRBaseControlDirectiveController } from "../base"


interface GroupsEditScope extends ScopeBaseGrid {
    dataGrid: DevExpress.ui.dxDataGrid
    columnsCount: number

    isLoading: boolean

    source: GridBridge
    popupOptions: DevExpress.ui.dxPopupOptions
    popupVisible: boolean
    popupTitle: string

    editReference: EditReference
    popupGridOptions: GridOptions
    referenceTableLoad: boolean
    chooseButtonOptions: DevExpress.ui.dxButtonOptions
    applyButtonOptions: DevExpress.ui.dxButtonOptions
    chooseButtonDisabled: boolean
    applyButtonDisabled: boolean
    applyButtonVisible: boolean
    md5: Md5Objects
    progressBarOptions: DevExpress.ui.dxProgressBarOptions
    isProgressBarVisible: boolean
}

interface EditReference {
    editReferenceButtonDisabled: boolean
    rowId: number
    popover: DevExpress.ui.dxPopover
    popoverOptions: DevExpress.ui.dxPopoverOptions
    popoverVisible: boolean

    popoverGrid: DevExpress.ui.dxDataGrid
    popoverGridOptions: GridOptions

    popoverObjectId: number

    isUnknownReferenceTable: boolean
    buttonNumber: number
}

export class GridEditController extends IMRBaseControlDirectiveController {
    rowElement: any
    srcServiceName: string
    srcMethodName: string
    objectReferenceModel: ObjectReferenceModel
    editedItem: any
    chooseButton: DevExpress.ui.dxButton
    gridButtons: any[]

    constructor(
        protected $scope: GroupsEditScope,
        protected $compile: ng.ICompileService,
        protected $q: ng.IQService,
        protected $timeout: ng.ITimeoutService,
        protected api: Api,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        private dateBoxControlsService: DateBoxControlsService,
        private validationControlsService: ValidationControlsService
    ) {
        super()

        $scope.isLoading = false

        $scope.md5 = {
            previousElementsMd5: "",
            previousSaveRequestMd5: ""
        }
        $scope.applyButtonDisabled = true
        $scope.chooseButtonDisabled = true
        $scope.popupVisible = false
        $scope.popupTitle = $scope.source.title
        $scope.popupOptions = {
            showTitle: true,
            showCloseButton: true,
            bindingOptions: {
                visible: 'popupVisible',
                title: 'popupTitle'
            },

            onHidden: () => {
                if ($scope.source.onHidden != null) {
                    $scope.source.onHidden()
                }
            },

            onHiding: (e: any) => {
                $scope.$root.$broadcast(EventsNames.CLOSE_GRID_EDIT_POPUP + $scope.source.popupId)
                $scope.editReference.buttonNumber = 0

                if ($scope.source.onHiding != null) {
                    $scope.source.onHiding(e)
                }
            },
            onShowing: () => {
                $scope.md5 = {
                    previousElementsMd5: "",
                    previousSaveRequestMd5: ""
                }
                $scope.$root.$broadcast(EventsNames.SHOWING_GRID_EDIT_POPUP)
            }
        }

        let dataSource: ArrayStore
        $scope.$on(EventsNames.OPEN_GRID_EDIT_POPUP + $scope.source.popupId, (event: ng.IAngularEvent, ...args: any[]) => {
            $scope.applyButtonVisible = args[1];
            if ($scope.dataGrid) {
                $scope.dataGrid.option("dataSource").store().clear()
                dataSource = $scope.dataGrid.option("dataSource").store()
                $scope.dataGrid.refresh()
            }

            $scope.source.refresh = true

            $timeout(() => {
                load(args).then(() => {
                    if ($scope.source.items) {
                        var currentDataSource = []
                        $scope.source.items.forEach((element, index) => {
                            element["VisibleIndex"] = index
                            $scope.dataGrid.option('dataSource').store().insert(element)
                        })
                        $scope.dataGrid.refresh()
                        dataSource = $scope.dataGrid.option('dataSource').store()
                    }
                })
            })
            $scope.popupVisible = true
        })

        var createEditReferenceObjectColumn = (hint: string, columnsName: string, serviceName: string, methodName: string, gridName: string) => {
            var editReferenceObjectColumn: ColumnModel = <any>{
                idName: 'editReferenceObject',
                cellTemplate: (container, options) => {
                    if (options.data.referenceType != "") {
                        var buttonOptions = {
                            hint: hint,
                            icon: 'edit',
                            onClick: (e) => {
                                var oldTarget = $scope.editReference.popover.option('target')
                                var newTarget = angular.element(e.element)

                                if (oldTarget == null || oldTarget != null && !newTarget.is(oldTarget)) {
                                    $scope.editReference.popover.option("target", newTarget)
                                    $scope.editReference.popover.option('visible', true)

                                    $scope.editReference.popoverObjectId = options.data[CommonHelper.idField]
                                    $scope.editReference.rowId = options.data.id
                                } else {
                                    $scope.editReference.popover.option('visible', !$scope.editReference.popover.option('visible'))
                                }

                                getData(columnsName, serviceName, methodName, gridName)
                            }
                        }

                        var button = $('<div class="edit-reference-button' + $scope.editReference.buttonNumber + '"></div>')
                        button.dxButton(buttonOptions)
                        button.appendTo(container)
                    }
                    $scope.editReference.buttonNumber++
                },
                name: '',
                referenceTypeId: null,
                sortDesc: false,
                type: 0,
                unitId: null,
                unitName: '',
                where: null,
                width: 70,
                isEditable: false,
                alignment: 'center',
                allowSorting: false,
                filterOperations: []
            }
            return editReferenceObjectColumn
        }

        var getColumns = (): ng.IPromise<any> => {
            var deferred = $q.defer<ColumnModel[]>()

            if ($scope.source.columns) {
                deferred.resolve($scope.source.columns)
            } else {
                localDictionary[$scope.source.dictionaryMethodName]().then(columns => deferred.resolve(columns))
            }

            return deferred.promise.then(defaultColumns => {
                $scope.columnsCount = defaultColumns.length

                var columns = defaultColumns.map((value) => {
                    var column = {
                        dataField: value['temporaryIdDataField'] ? value['temporaryIdDataField'] : value.name.toLocaleLowerCase(), // value['temporaryIdDataField'] rozwiązanie tymaczasowe dla zapewnienia kompatybilności, docelowo zamienic na OpDataType.toString() więcej info Adam Małyszko/Krzysztof Myrcik
                        caption: value.caption,
                        dataType: CommonHelper.getDataType(value)
                    }

                    return column
                })

                return columns
            })
        }

        var getMetersColumns = () => {
            return getColumns().then(columns => {
                var editReferenceObjectColumn = createEditReferenceObjectColumn(i18n('Popup', 'ConnectDevice'), 'getDevicesDefaultColumns', 'device', 'getDevices', 'DevicesJoinGrid')
                this.srcServiceName = 'meter'
                this.srcMethodName = 'changeCurrentDevice'
                columns.push(editReferenceObjectColumn)
                return columns
            })
        }

        var getDevicesColumns = () => {
            return getColumns().then(columns => {
                var editReferenceObjectColumn = createEditReferenceObjectColumn(i18n('Popup', 'ConnectMeter'), 'getMeterDefaultColumns', 'meter', 'getMeters', 'MetersJoinGrid')
                this.srcServiceName = 'device'
                this.srcMethodName = 'changeCurrentMeter'
                columns.push(editReferenceObjectColumn)
                return columns
            })
        }

        var getInstalledDevicesColumns = () => {
            return getColumns().then(columns => {
                this.srcServiceName = 'device'
                this.srcMethodName = 'changeUsedEquipment '

                return columns
            })
        }

        var getRoutePointsColumns = () => {
            return getColumns().then(columns => {
                columns.forEach(column => {
                    column.allowSorting = false
                })
                columns.push({
                    dataField: "VisibleIndex",
                    caption: "VisibleIndex",
                    allowSorting: false,
                    visible: false,
                    sortIndex: 0, sortOrder: 'asc'
                })
                return columns
            })
        }

        var getMinStatesColumns = () => {
            return getColumns().then(columns => {
                _.forEach(columns, (column: any) => {
                    column.allowEditing = false
                })

                columns.push({
                    allowEditing: true,
                    dataField: 'amount',
                    dataType: 'number',
                    caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Amount),

                    validationRules: [
                        this.validationControlsService.getPositiveIntegerRule(),
                        this.validationControlsService.getRequiredRule(),
                        this.validationControlsService.getNumberGreaterThanRule(1)
                    ]

                })

                return columns
            })
        }

        var getPackageContentColumns = () => {
            var columns = [{
                allowEditing: false,
                dataField: 'article',
                dataType: 'string',
                caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Name),
            },
            {
                allowEditing: true,
                dataField: 'externalSn',
                dataType: 'string',
                caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SerialNbr),
            },
            {
                allowEditing: true,
                dataField: 'notes',
                dataType: 'string',
                caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Notes),
            },]
            return columns
        }

        var getAlarmGroupsOperatorsColumns = () => {
            const columns = [{
                allowEditing: false,
                dataField: 'name',
                dataType: 'string',
                caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Operator),
            }]

            return columns
        }

        var getDistributorSuppliersColumns = () => {
            const columns = [{
                allowEditing: false,
                dataField: 'name',
                dataType: 'string',
                caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Name),
            }]

            return columns
        }

        var getOperatorTechnicalColumns = () => {
            return getColumns().then(columns => {
                _.forEach(columns, (column: any) => column.allowEditing = false)

                const now: Date = TypeHelper.stripSeconds(new Date())
                const displayFormat: string = ConfigHelper.getDateFormat(ConfigHelper.DateFormat.DATE_TIME_FORMAT_MOMENTJS)
                const startTimedateBoxOptions: DevExpress.ui.dxDateBoxOptions = this.dateBoxControlsService.getDateBoxOptions({
                    format: ConfigHelper.getDateFormat(ConfigHelper.DateFormat.DATE_TIME_FORMAT_DX)
                })

                const endTimeDateBoxOptions: DevExpress.ui.dxDateBoxOptions = this.dateBoxControlsService.getDateBoxOptions({
                    format: ConfigHelper.getDateFormat(ConfigHelper.DateFormat.DATE_TIME_FORMAT_DX)
                })

                startTimedateBoxOptions.value = undefined
                startTimedateBoxOptions.min = now
                startTimedateBoxOptions.valueChangeEvent = 'keyup'
                startTimedateBoxOptions.validationMessageMode = 'always'

                endTimeDateBoxOptions.value = undefined;
                endTimeDateBoxOptions.min = now
                endTimeDateBoxOptions.valueChangeEvent = 'keyup'
                endTimeDateBoxOptions.validationMessageMode = 'always'

                const startTimeColumn: DevExpress.ui.dxDataGridColumn = {
                    allowEditing: true,
                    dataField: 'startTime',
                    dataType: 'datetime',
                    caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.StartTime),
                    editorOptions: startTimedateBoxOptions,
                    validationRules: [
                        this.validationControlsService.getRequiredRule(),
                    ],

                    customizeText(options) {
                        if (options.value) {
                            return moment(options.value).format(displayFormat)
                        }
                        return ''
                    }
                }

                const endTimeColumn: DevExpress.ui.dxDataGridColumn = {
                    allowEditing: true,
                    dataField: 'endTime',
                    dataType: 'datetime',
                    caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.EndTime),
                    editorOptions: endTimeDateBoxOptions,

                    customizeText(options) {
                        if (options.value) {
                            return moment(options.value).format(displayFormat)
                        }
                        return ''
                    }
                }

                columns.push(startTimeColumn, endTimeColumn, {
                    allowEditing: true,
                    dataField: 'notes',
                    dataType: 'text',
                    caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Notes),
                })

                return columns
            })
        }

        var initializeGrid = (columns, deferred, editable = false, customOptions: DevExpress.ui.dxDataGridOptions = null) => {
            $scope.popupGridOptions = null
            $timeout(() => {
                $scope.popupGridOptions = {
                    type: GridTypes.PAGINATED_SMALL,
                    idReferenceType: Enums.ReferenceType.None,
                    name: 'EditGrid' + $scope.source.title,
                    columns: columns,
                    onInitialized: (e, grid) => {
                        $scope.dataGrid = e.component
                        deferred.resolve()
                        if ($scope.source.onGridInitialized) {
                            $scope.source.onGridInitialized(e, grid)
                        }

                        if ($scope.source.onControllerInitialized) {
                            $scope.source.onControllerInitialized(this)
                        }
                    },
                    onCellPrepared: (options: any) => {
                        if ($scope.source.onCellPrepared) {
                            $scope.source.onCellPrepared(options)
                        }
                    },

                    onEditorPreparing: (e: any) => {
                        if ($scope.source.onEditorPreparing) {
                            $scope.source.onEditorPreparing(e)
                        }

                        this.onEditorPreparing(e)
                    },

                    buttonsOptions: $scope.source.buttons != null ? $scope.source.buttons : { enabled: false },
                    addCustomFilters: true,
                    allowColumnReordering: $scope.source.allowColumnReordering != null ? $scope.source.allowColumnReordering : true,
                    ignoreKey: true,
                    masterDetail: $scope.source.masterDetail != null ? $scope.source.masterDetail : false
                }

                if (editable) {
                    $scope.popupGridOptions.editing = {
                        allowUpdating: true,
                        mode: 'cell'
                    }

                    $scope.popupGridOptions.onRowUpdated = (e: any) => {
                        e.component
                            .byKey(e.key)
                            .then((gridObject) => {

                                if (gridObject != null && !gridObject.isNew && !gridObject.isRemoved) {
                                    gridObject.isEdited = true
                                }

                                e.component.repaint()
                            })
                    }
                }


                if (customOptions != null) {
                    $scope.popupGridOptions = _.assign({}, $scope.popupGridOptions, customOptions)
                }
            })
        }

        var initalizeRoutePointsGrid = (columns, deferred) => {
            $scope.popupGridOptions = null
            $timeout(() => {
                this.$scope.popupGridOptions = {
                    type: GridTypes.PAGINATED_SMALL,
                    idReferenceType: Enums.ReferenceType.None,
                    name: 'EditGrid',
                    needCustomFilter: true,
                    columns: columns,
                    dataSource: new DataSource([]),
                    allowColumnReordering: $scope.source.allowColumnReordering != null ? $scope.source.allowColumnReordering : true,

                    dragging: {
                        allowReordering: true,
                        showDragIcons: false,
                        onReorder: (e) => {
                            const sourceRowIndex: number = e.fromIndex
                            const targetRowIndex: number = e.toIndex
                            const draggingDirection: number = (targetRowIndex < sourceRowIndex) ? 1 : -1;
                            let dataItems = null

                            dataSource.load().done(function (data) {
                                dataItems = data;
                            });

                            for (let dataIndex = 0; dataIndex < dataItems.length; dataIndex++) {
                                if (dataItems[dataIndex].VisibleIndex == null) {
                                    dataItems[dataIndex].VisibleIndex = dataIndex
                                }
                            }

                            for (let dataIndex = 0; dataIndex < dataItems.length; dataIndex++) {
                                if ((dataItems[dataIndex].VisibleIndex > Math.min(targetRowIndex, sourceRowIndex)) && (dataItems[dataIndex].VisibleIndex < Math.max(targetRowIndex, sourceRowIndex))) {
                                    dataItems[dataIndex].VisibleIndex += draggingDirection;
                                }
                            }

                            dataSource.update($scope.dataGrid.getKeyByRowIndex(sourceRowIndex), {
                                VisibleIndex: targetRowIndex,
                                isEdited: true
                            });

                            dataSource.update($scope.dataGrid.getKeyByRowIndex(targetRowIndex), {
                                VisibleIndex: targetRowIndex + draggingDirection,
                                isEdited: true
                            });

                            let start, end
                            if (sourceRowIndex > targetRowIndex) {
                                start = targetRowIndex
                                end = sourceRowIndex
                            } else {
                                start = sourceRowIndex
                                end = targetRowIndex
                            }

                            for (let i = start; i < end; i++) {
                                const key = $scope.dataGrid.getKeyByRowIndex(i)

                                dataSource.update(key, {
                                    isEdited: true
                                });
                            }

                            $scope.dataGrid.refresh()

                            //MAKE SUBMIT BTN ACTIVE 
                            $scope.$broadcast(EventsNames.ROUTE_POINT_DRAG_AND_DROP + $scope.source.id)

                        }
                    },

                    onInitialized: e => {
                        $scope.dataGrid = e.component
                        deferred.resolve()

                        if ($scope.source.onControllerInitialized) {
                            $scope.source.onControllerInitialized(this)
                        }
                    },
                    onContentReady: (e) => {
                        // initDragging(e);
                    },
                    buttonsOptions: {
                        enabled: true
                    },
                    addCustomFilters: true
                }
            })
        }

        var load = (args: any = null) => {
            var deferred = $q.defer()
            if (args == null || args.length == 0) {
                getColumns().then(columns => {
                    initializeGrid(columns, deferred)
                })
            }
            else {
                switch (args[0]) {
                    case "locationDevices":
                        getDevicesColumns().then(columns => {
                            initializeGrid(columns, deferred)
                        })
                        break
                    case "locationMeters":
                        getMetersColumns().then(columns => {
                            initializeGrid(columns, deferred)
                        })
                        break

                    case "routePoints":
                        getRoutePointsColumns().then(columns => {
                            initalizeRoutePointsGrid(columns, deferred)
                        })
                        break
                    case "installedEquipment":
                        getInstalledDevicesColumns().then(columns => {
                            initializeGrid(columns, deferred)
                        })
                        break
                    case 'depositoryMinState':
                        getMinStatesColumns().then(columns => {
                            initializeGrid(columns, deferred, true)
                        })
                        break

                    case 'operatorTechnicalPermissions':
                        getOperatorTechnicalColumns().then(columns => {
                            const customGridOptions: DevExpress.ui.dxDataGridOptions = {
                                onEditorPreparing: (e: any) => {
                                    this.onEditorPreparing(e)

                                    if (e.parentType != "dataRow") return

                                    if (e.dataField === 'startTime') {
                                        const org = e.editorOptions.onValueChanged
                                        e.editorOptions.onValueChanged = (eEditor) => {
                                            eEditor.value = TypeHelper.stripSeconds(eEditor.value)

                                            if (!e.row.data.isNew && !e.row.data.isRemoved) {
                                                e.row.data.isEdited = true
                                            }

                                            const startDatePlusMonth = TypeHelper.addToDate(eEditor.value, 'month', 1)
                                            if (e.row.data.endTime != null && moment(startDatePlusMonth).isAfter(e.row.data.endTime)) {
                                                e.row.data.endTime = startDatePlusMonth
                                            }

                                            if (org != null) {
                                                org(eEditor)
                                            }
                                        }
                                    }

                                    if (e.dataField === 'endTime') {
                                        if (e.row.data.startTime != null) {
                                            e.editorOptions.min = TypeHelper.addToDate(e.row.data.startTime, 'month', 1)
                                        }

                                        const org = e.editorOptions.onValueChanged
                                        e.editorOptions.onValueChanged = (eEditor) => {
                                            eEditor.value = TypeHelper.stripSeconds(eEditor.value)

                                            if (!e.row.data.isNew && !e.row.data.isRemoved) {
                                                e.row.data.isEdited = true
                                            }

                                            if (org != null) {
                                                org(eEditor)
                                            }
                                        }
                                    }
                                },
                            }

                            initializeGrid(columns, deferred, true, customGridOptions)
                        })
                        break
                    case 'packageContentColumns':
                        initializeGrid(getPackageContentColumns(), deferred, true)
                        break
                    case 'alarmGroupsOperators':
                        initializeGrid(getAlarmGroupsOperatorsColumns(), deferred, true)
                        break
                    case 'distributorSuppliers':
                        initializeGrid(getDistributorSuppliersColumns(), deferred, true)
                        break
                    default:
                        getColumns().then(columns => {
                            initializeGrid(columns, deferred)
                        })
                        break
                }
            }
            return deferred.promise
        }

        //editReference
        $scope.editReference = <EditReference>{}
        $scope.editReference.buttonNumber = 0
        $scope.editReference.popoverOptions = {
            width: 600,
            height: 500,
            onInitialized: (e) => {
                $scope.editReference.popover = e.component
            },
            target: null,
            onHidden: () => {
                $scope.editReference.popoverGrid.deselectAll()
                $scope.chooseButtonDisabled = true
                $scope.applyButtonDisabled = true
                this.rowElement = undefined
                this.objectReferenceModel = undefined
            },
            closeOnOutsideClick: true
        }

        var createReferenceGrid = (apiReq, gridName, onRowClick, columns, columnsReorderingDisabled) => {
            $scope.editReference.popoverGridOptions = {
                addCustomFilters: true,
                name: gridName,
                type: GridTypes.PAGINATED_SMALL,
                idReferenceType: Enums.ReferenceType.None,
                columnsDictionary: columns,
                allowColumnReordering: !columnsReorderingDisabled,

                buttonsOptions: {
                    enabled: false
                },

                request: (e) => {
                    $scope.referenceTableLoad = true
                    return apiReq(e).then(result => {
                        $scope.referenceTableLoad = false
                        return result
                    })
                },

                onRowDoubleClick: (e) => {
                    this.rowElement = e.data
                    onRowClick(this.rowElement)
                    $scope.editReference.popover.option('visible', false)
                    $scope.$broadcast(EventsNames.CONNECT_TO_LOCATION, this.srcServiceName, this.srcMethodName, this.objectReferenceModel, this.rowElement)
                },

                onInitialized: (e) => {
                    $scope.editReference.popoverGrid = e.component
                },

                onContentReady: () => {
                    $scope.editReference.popoverGrid.deselectAll()
                    $scope.chooseButtonDisabled = true
                },

                onSelectionChanged: () => {
                    if ($scope.editReference.popoverGrid.getSelectedRowsData().length == 1) {
                        $scope.chooseButtonDisabled = false
                        this.rowElement = $scope.editReference.popoverGrid.getSelectedRowsData()[0]
                    }
                    else {
                        $scope.chooseButtonDisabled = true
                    }
                    this.chooseButton.repaint()
                }
            }
        }

        var onClickFn = (data: any) => {
            if (data && $scope.editReference.popoverObjectId) {
                this.objectReferenceModel = new ObjectReferenceModel()
                this.objectReferenceModel.id = $scope.editReference.popoverObjectId
                this.objectReferenceModel.referenceObjectId = data[CommonHelper.idField]
                this.editedItem = $scope.dataGrid["_options"].dataSource._items.filter(item => { return item.id == $scope.editReference.rowId })[0]
                this.editedItem.isEdited = true
                $scope.dataGrid.refresh()
                CommonHelper.openInfoPopup(i18n('Popup', 'ReferenceObjectIsChosen'), 'info')
                $scope.applyButtonDisabled = false
            }
        }

        // getting data to grid in popover (editting reference object)
        var getData = (columnsName: string, serviceName: string, methodName: string, gridName: string) => {
            $scope.editReference.isUnknownReferenceTable = false
            let columnDeferred = $.Deferred()

            if (this.$scope.source.popupColumns != null) {
                columnDeferred.resolve(this.$scope.source.popupColumns)
            }
            else {
                localDictionary[columnsName]().then(columns => columnDeferred.resolve(columns))
            }

            columnDeferred.then(columns => {
                var apiReq = (request) => {
                    if ($scope.source.dataMethodName === 'getOperatorDepositoryContent') {
                        const idOperator = api.login.getUser().id;
                        return api.users.getOperatorDepositoryContent(idOperator)
                            .then((res: any) => {
                                const newRes = {
                                    values: res.map(el => {
                                        const obj = {}
                                        for (let key in el.device.dynamicValues)
                                            obj[key.toLowerCase()] = el.device.dynamicValues[key]
                                        return obj
                                    }),
                                    totalCount: res.length
                                }
                                return newRes
                            })
                    }
                    else {
                        return api[serviceName][methodName](request)
                    }
                }
                Permissions.hasPermissions([serviceName.toUpperCase() + '_MODULE_MAIN_GRID_COLUMN_REORDER_DISALLOWED']).then(columnsReorderingDisabled => {
                    createReferenceGrid(apiReq, gridName, onClickFn, columns, columnsReorderingDisabled)
                })
            })
        }

        $scope.chooseButtonOptions = {
            text: i18n("Common", "Choose"),
            onClick: () => {
                $scope.editReference.popover.option('visible', false)
                onClickFn(this.rowElement)
                $scope.$broadcast(EventsNames.CONNECT_TO_LOCATION, this.srcServiceName, this.srcMethodName, this.objectReferenceModel, this.rowElement)
            },
            onInitialized: e => {
                this.chooseButton = e.component
            },
            bindingOptions: {
                disabled: "chooseButtonDisabled"
            }
        }

        $scope.applyButtonOptions = {
            text: i18n("Common", "Apply"),
            onClick: () => {
                saveReferenceObject()
            },
            bindingOptions: {
                disabled: "applyButtonDisabled",
                visible: "applyButtonVisible"
            }
        }
        //end edit reference

        var saveReferenceObject = () => {
            $scope.applyButtonDisabled = true
            api[this.srcServiceName][this.srcMethodName](this.objectReferenceModel).then(result => {
                this.editedItem.isEdited = false
                this.objectReferenceModel = undefined
                $scope.dataGrid.refresh()
                if (result) {
                    CommonHelper.openInfoPopup(i18n('Popup', 'ReferenceObjectChanged'), 'success')
                }
            })
        }

        $scope.$watchCollection('source.items', (items: any[]) => {
            if ($scope.dataGrid) {
                $scope.dataGrid.option("dataSource").store().clear()
                items.forEach((item) => {
                    $scope.dataGrid.option("dataSource").store().insert(item)
                })
                $scope.dataGrid.refresh()
            }
            $scope.popupTitle = $scope.source.items ? $scope.source.title + " (" + $scope.source.items.length + ")" : $scope.source.title
        })

        $timeout(() => {
            this.initializeProgressBar()
        }, 100)
    }

    //#region Editors

    private onEditorPreparing(e: any): void {
        e.editorOptions.onFocusOut = (e: any) => {
            if (_.isFunction(this.$scope.source.handleSubmitButton)) {
                this.$scope.source.handleSubmitButton(false)
            }
        }

        e.editorOptions.onKeyDown = (e: any) => {
            if (_.isFunction(this.$scope.source.handleSubmitButton)) {
                this.$scope.source.handleSubmitButton(true)
            }
        }
    }

    //#endregion

    //#region Loading Contaier

    private progressDeferred: JQueryDeferred<DevExpress.ui.dxProgressBar> = $.Deferred<DevExpress.ui.dxProgressBar>()

    public setIsLoading(value: boolean): void {
        this.$scope.isLoading = value
    }

    public toggleProgressBar(isVisible: boolean = false): void {
        this.$scope.isProgressBarVisible = isVisible
    }

    public setProgress(progress: number): void {
        this.progressDeferred.then((progressBar: DevExpress.ui.dxProgressBar) => {
            progressBar.option('value', progress)
        })
    }

    private initializeProgressBar(): void {
        this.$scope.progressBarOptions = {
            min: 0,
            max: 101,
            value: 0,
            showStatus: true,
            width: '50%',

            onInitialized: (e: any) => {
                this.progressDeferred.resolve(e.component)
            },

            statusFormat: (progress) => {
                return (progress * 100).toFixed(2).toString() + ' %'
            }
        }
    }

    //#endregion
}